import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

import Login from "./components/auth/Login"
import Signup from "./components/auth/Signup"
import ForgotPassword from "./components/auth/ForgotPassword"
import ResetPassword from "./components/auth/ResetPassword"
import Landing from './Landing';

import { AuthProvider } from "./components/auth/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { register as registerSW } from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* ✅ SINGLE GLOBAL ROUTER */}
      <AuthProvider>

        <Routes>

          <Route path="/" element={<Landing />} />

          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Protected App */}
          <Route path="/*" element={
            <ProtectedRoute>
            <App />
            </ProtectedRoute>
          }/>
          {/* <Route path="/expense/*" element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          }/>

          <Route path="/planner/*" element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          }/>

          <Route path="/investments/*" element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          }/> */}


          {/* Default */}
          <Route path="*" element={<Login />} />

        </Routes>

      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
registerSW();
